import React from 'react';
import { Button as AntDesignButton } from 'antd';
import './styles.css';

const Button = props => {
  return <AntDesignButton {...props} className="cb-button" />;
};

export default Button;
